import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    // On tickets page, set active link in menu based on query string in URL
    const urlParams = new URLSearchParams(window.location.search);
    $('.ticx-container .sub-nav__list .sub-nav__link').each((index, link) => {
        const $link = $(link);
        if (urlParams.has('flow') && $link.attr('href').includes(urlParams)) {
            $link.parent().addClass('sub-nav__item--active');
        }
    });

    // On tickets page, prevent user from clicking active link (prevents issue on mobile dropdown)
    const activeLink = $('.ticx-container .sub-nav__list .sub-nav__item--active');
    activeLink.on('click', (e) => {
        e.preventDefault();
    });
});
